import { BaseService, ErrorResponse } from "../base";
import type { StorageItem } from "./model";

export interface IStorageService {
  GetBlob(blobId: string): Promise<Blob | null>;
  GetAsset(assetId: string): Promise<Blob | null>;
  CreateBlob(item: StorageItem): Promise<StorageItem | null>;
  DeleteBlob(item: StorageItem): Promise<void>;
}

export class StorageService extends BaseService implements IStorageService {
  constructor(baseUri: string, token: string) {
    super(baseUri, token);
  }

  async GetBlob(blobId: string | undefined): Promise<Blob | null> {
    if(!blobId)
      return null;

    let result: Blob | ErrorResponse = await this.Get<Blob>(blobId, true, true);

    if (result instanceof ErrorResponse) {
      return null;
    }

    return result;
  }

  async GetAsset(assetId: string): Promise<Blob | null> {
    let result: Blob | ErrorResponse = await this.Get<Blob>(`assets/${assetId}`, true, true);

    if (result instanceof ErrorResponse) {
      return null;
    }

    return result;
  }

  async CreateBlob(item: StorageItem | undefined): Promise<StorageItem | null> {
    let result: StorageItem | ErrorResponse = await this.Post('', true, item);
    
    if (result instanceof ErrorResponse) {
      return null;
    }

    return result;
  }

  async DeleteBlob(item: StorageItem): Promise<void> {
    if (!item.blobId) { 
      return;
    }

    await this.Delete(item.blobId);
  }
}